function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.53,4.531H16.286a1.249,1.249,0,0,0-1.381-1.224h-11A1.249,1.249,0,0,0,2.53,4.531ZM3.5,19.307H15.308a2.314,2.314,0,0,0,2.605-2.58V8.451a2.314,2.314,0,0,0-2.605-2.58H3.5A2.307,2.307,0,0,0,.895,8.451v8.275A2.311,2.311,0,0,0,3.5,19.307ZM9.416,13.8a2.558,2.558,0,0,1-2.457-2.687A2.549,2.549,0,0,1,9.416,8.476a2.55,2.55,0,0,1,2.465,2.638A2.529,2.529,0,0,1,9.416,13.8ZM4.749,17.754a4.881,4.881,0,0,1,4.668-2.81,4.885,4.885,0,0,1,4.676,2.81Z",
  transform: "translate(-0.395 -2.807)",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

function SvgFullProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.019 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullProfile);
export default __webpack_public_path__ + "static/media/full_profile.44ccf6f2.svg";
export { ForwardRef as ReactComponent };